import { createApp } from 'vue'
import NewCarLoanCalculatorAdjustLoan from './NewCarLoanCalculatorAdjustLoan'
import handleComponentProps from '../../../../foundation/js/utils/handleComponentProps.js'

const el = '.nyk-component--new-car-loan-calculator-adjust-loan'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((NewCarLoanCalculatorAdjustLoanDOM) => {
            const props = handleComponentProps(NewCarLoanCalculatorAdjustLoan, NewCarLoanCalculatorAdjustLoanDOM)
            const component = createApp(NewCarLoanCalculatorAdjustLoan, props).use(Store)
            component.mount(NewCarLoanCalculatorAdjustLoanDOM)
        })
    }
}
